"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onNotificationEvent = exports.notificationCallback = void 0;
let globalNotificationCallback = null;
/**
 * This is used internally to handle notification events sent from the native
 * side.
 */
exports.notificationCallback = (...args) => globalNotificationCallback === null || globalNotificationCallback === void 0 ? void 0 : globalNotificationCallback(...args);
/** Sets a handler for notification events. */
exports.onNotificationEvent = (callback) => {
    globalNotificationCallback = callback;
};
//# sourceMappingURL=notification-callback.js.map